import { GamesTemplate } from '@/components/templates/GameZone'
import { useAppModal, AppModals } from '@/context/ModalProvider'
import { useMaintenance } from '@/hooks/useMaintenance'
import { useEffect } from 'react'

const GamesPage = () => {
  const { isMaintenance } = useMaintenance()
  const modal = useAppModal()

  useEffect(() => {
    if (isMaintenance) {
      modal.openModalNew(AppModals.MaintenanceModal)
    }
  }, [])

  return <GamesTemplate />
}

export default GamesPage
